import { render, staticRenderFns } from "./HeaderSivoa.vue?vue&type=template&id=053ec0b0&scoped=true&"
import script from "./HeaderSivoa.vue?vue&type=script&lang=js&"
export * from "./HeaderSivoa.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSivoa.vue?vue&type=style&index=0&id=053ec0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ec0b0",
  null
  
)

export default component.exports